import { Tag, TopicType } from '../../ontology.model';

export const algebraTags: Tag[] = [
  {
    id: 'tag.alg',
    name: 'Algebra',
    topic_type: TopicType.Algebraic,
    color: '#3b82f6',
    icon: 'function',
  },
];
